'use client';

import { usePathname } from 'next/navigation';
import { useCallback } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { agenteStore } from '@/infrastructure/store/agenteStore';

import { IScreenContext } from '../interfaces/agente';

export function useAgente() {
  const pathname = usePathname();

  const state = useStore(
    agenteStore,
    useShallow((s) => ({
      conversa: s.conversa,
      saude: s.saude,
      painelAberto: s.painelAberto,
      loading: s.loading,
      loadingConfirmar: s.loadingConfirmar,
      erro: s.erro,
      abrirPainel: s.abrirPainel,
      fecharPainel: s.fecharPainel,
      togglePainel: s.togglePainel,
      enviar: s.enviar,
      confirmar: s.confirmar,
      limpar: s.limpar,
      carregarConversa: s.carregarConversa,
      carregarSaude: s.carregarSaude,
    })),
  );

  const contextoAtual = useCallback((): IScreenContext => {
    return { rota: pathname };
  }, [pathname]);

  return { ...state, contextoAtual };
}
